import Splide from '@splidejs/splide';

new Splide('.quotes-splide', {
	type: 'loop',
	arrows: true,
	pagination: false,
	autoplay: true
}).mount();
